module.exports = __webpack_public_path__ + "img/23-2.04c367f8.png";